import { getInvoiceTypeCodeString } from '.'
import { UblInvoice } from '../../data/models'
import i18n from '../../utils/i18n'

export const InvoiceTypeBodyTemplate = (
  invoiceTypeCode: UblInvoice['InvoiceTypeCode'] | undefined | null,
) => {
  const { t } = i18n

  if (!invoiceTypeCode) return null

  const translation = t(
    `eInvoiceOverview.table.columns.invoiceType.options.${getInvoiceTypeCodeString(
      invoiceTypeCode.Value,
    )}`,
  )

  return <>{translation}</>
}
